import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { Redirect } from "react-router-dom";
import StatusBar from "./StatusBar";
import HoursTable from "./HoursTable";
import { UserConsumer } from "../../../UserContext";
import { myOfficeHoursAPIs } from "./myOfficeHoursAPIs";
import Header from "../../../components/Header";
import { AlertPopups } from "../../../components/AlertPopups";
import { APIDateFormat } from "../../Dashboard/DashboardVariables";

const ExportAttendance = () => {
	let token = null;
	let date = new Date();
	let currentYear = date.getFullYear();
	const [startDate, setStartDate] = useState(new Date(`${currentYear}-1-1`));
	const [endDate, setEndDate] = useState(date);
	const [pagerData, setPagerData] = useState(null);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(200);
	const [status, setStatus] = useState([]);
	const [selectedEmp, setSelectedEmp] = useState(null);
	const [tableData, setTableData] = useState([]);
	const [startDateCalendar, setStartDateCalendar] = useState(false);
	const [endDateCalendar, setEndDateCalendar] = useState(false);
	const [workStatus, setWorkStatus] = useState(-1);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		getWeeklyHours();
		getTotalHours();
		getOfficeHoursStatus();

		axios
			.get(
				`${
					myOfficeHoursAPIs.GetEmployeesAttendance_API
				}?FromDate=${moment(startDate).format(
					APIDateFormat
				)}&ToDate=${moment(endDate).format(
					APIDateFormat
				)}&PageSize=${numberOfItemsPerPage}&EmployeeId=${workStatus}&PageNumber=${1}&SortBy=recordId_desc`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setTableData(res.data.employeeAttendanceListing);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
				}
			});
	}, []);

	const startDateHandleChange = (date) => {
		setIsLoading(true);
		setStartDate(date);
		axios
			.get(
				`${
					myOfficeHoursAPIs.GetEmployeesAttendance_API
				}?FromDate=${moment(date).format(
					APIDateFormat
				)}&ToDate=${moment(endDate).format(
					APIDateFormat
				)}&EmployeeId=${workStatus}&PageSize=${numberOfItemsPerPage}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				setIsLoading(false);
				setTableData([...res.data.employeeAttendanceListing]);
				setPagerData(JSON.parse(res.headers["x-pagination"]));
			});
	};

	//handling end date filteration
	const endDateHandleChange = (date) => {
		setIsLoading(true);
		setEndDate(date);
		if (workStatus === 0) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Select Employee",
			});
		} else {
			axios
				.get(
					`${
						myOfficeHoursAPIs.GetEmployeesAttendance_API
					}?FromDate=${moment(startDate).format(
						APIDateFormat
					)}&ToDate=${moment(date).format(
						APIDateFormat
					)}&EmployeeId=${workStatus}&PageSize=${numberOfItemsPerPage}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					}
				)
				.then((res) => {
					setIsLoading(false);
					setTableData([...res.data.employeeAttendanceListing]);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
				});
		}
	};

	const getWeeklyHours = () => {
		axios
			.get(`${myOfficeHoursAPIs.GetWeeklyAndMonthlyHours}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {});
	};

	const getTotalHours = () => {
		startDate &&
			endDate &&
			axios.post(
				`${myOfficeHoursAPIs.GetTotalHoursAPI}`,
				{ startDate: startDate, endDate: endDate },
				{ headers: { Authorization: `Bearer ${token}` } }
			);
	};

	const getOfficeHoursStatus = () => {
		//api call to get status
		axios
			.get(`${myOfficeHoursAPIs.GetSupervisorEmployees_API}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				const sendData = [];
				if (res) {
					res.data.forEach((item) =>
						sendData.push({
							label: item.name,
							value: item.employeeId,
						})
					);
				}
				const defaultObj = { value: -1, label: "All" };
				sendData.unshift(defaultObj);
				setStatus(sendData);
				setSelectedEmp(defaultObj);
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: "Please Enter Start Date and End Date",
					});
				}
			});
	};

	const handleStatus = (obj) => {
		setIsLoading(true);
		//handling status filteration
		setWorkStatus(obj.value);
		setSelectedEmp(obj);
		axios
			.get(
				`${
					myOfficeHoursAPIs.GetEmployeesAttendance_API
				}?FromDate=${moment(startDate).format(
					APIDateFormat
				)}&ToDate=${moment(endDate).format(APIDateFormat)}&EmployeeId=${
					obj.value
				}&PageSize=${numberOfItemsPerPage}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				setIsLoading(false);
				setTableData([...res.data.employeeAttendanceListing]);
				setPagerData(JSON.parse(res.headers["x-pagination"]));
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: "Please Enter Start Date and End Date",
					});
				}
			});
	};

	//Calendar
	const startDateOpenCalendar = () => {
		if (startDateCalendar) {
			setStartDateCalendar(false);
		} else {
			setStartDateCalendar(true);
		}
	};
	//Calendar
	const endDateOpenCalendar = () => {
		if (endDateCalendar) {
			setEndDateCalendar(false);
		} else {
			setEndDateCalendar(true);
		}
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.empRole.includes("3") || //authorization
					userDetails.empRole.includes("5") ? (
					<div className="container-fluid pl-3 pr-3">
						<Header title="Export Attendance" headerBorder={true} />
						<StatusBar
							startDateHandleChange={startDateHandleChange}
							endDateHandleChange={endDateHandleChange}
							startDate={startDate}
							endDate={endDate}
							status={status}
							selectedEmp={selectedEmp}
							handleStatus={handleStatus}
							startDateOpenCalendar={startDateOpenCalendar}
							endDateOpenCalendar={endDateOpenCalendar}
							startDateCalendar={startDateCalendar}
							endDateCalendar={endDateCalendar}
						/>

						<HoursTable
							isLoading={isLoading}
							setIsLoading={(value) => setIsLoading(value)}
							startDate={startDate}
							status={status}
							endDate={endDate}
							tableData={tableData}
							setTableData={setTableData}
							pagerData={pagerData}
							setPagerData={setPagerData}
							workStatus={workStatus}
							setNumberOfItemsPerPage={setNumberOfItemsPerPage}
						/>
					</div>
				) : (
					<Redirect to="/MyDashboard" /> //redirection
				);
			}}
		</UserConsumer>
	);
};

export default ExportAttendance;
